module.exports = __webpack_public_path__ + "static/media/celtic-holidays-brochure-design-2.a9559ae6.jpg";